import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ChipContainer = styled.div`
  width: ${({ width }) => width + 'px'};
  height: ${({ height }) => height + 'px'};
  border: 4px solid rgba(0, 115, 234, 0.4);
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  background-color: #e6e9ef;
  top: ${({ y }) => y + 'px'};
  left: ${({ x }) => x + 'px'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 0;
  font-size: 11px;
  line-height: 22px;
  color: #0073ea;
  font-weight: 400;
  cursor: pointer;
  overflow: hidden;
  pointer-events: auto;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
`;

const Chips = ({ x, y, item, handleClick }) => {
  const noPadding = item.noPadding || false;
  const padding = noPadding ? 0 : 6;
  const defaultHeight = 26.66;
  const defaultWidth = 183.33;

  const { t } = useTranslation();
  return (
    <ChipContainer
      x={x+padding}
      y={y+padding}
      onClick={handleClick}
      width={item.width || defaultWidth}
      height={item.height || defaultHeight}
    >
      {item?.title.includes('Signature') ? t('Signature') : t('Initials')}
    </ChipContainer>
  );
};

export default Chips;
